import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  bp,
  flexCenter,
  flexColumn,
  flexSpBetween,
  media,
  rem,
} from "@styles/Utilities.styled";


export const StyledDocumentation = styled.section`
  margin-bottom: 8rem;

  .header {
    ${flexColumn}
    gap: 1.5rem;
    padding-top: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

    ${media(bp.medium)} {
      ${flexSpBetween}
      flex-direction: row;
    }

    h1 {
      font-weight: 500;
      font-size: ${rem(20)};
    }
  }

  .table-header {
    ${flexSpBetween}
    gap: 1rem;
    margin-top: 2rem;

    p {
      color: var(--clr-primary-400);
      font-size: ${rem(15)};
      font-weight: 500;
      white-space: nowrap;
    }

    .filter-tags {
      ${alignItemsCenter}
      gap: 0.5rem;
      /* margin-left: 1.5rem; */
      /* outline: 1px solid red; */

      ${media(bp.large1)} {
        margin-left: 2rem;
      }

      &-item {
        ${alignItemsCenter}
        gap: 0.5em;
        width: fit-content;
        font-size: ${rem(14)};
        font-weight: 500;
        padding: 0.4em 0.6em;
        line-height: 1;
        border-radius: var(--border-radius-2);
        color: var(--clr-primary-400);
        background-color: var(--clr-primary-100);
        white-space: nowrap;

        button {
          ${flexCenter}
          color: var(--clr-primary-400);

          svg {
            font-size: ${rem(15)};
          }
        }
      }
    }
  }
`;
